<ng-container *transloco="let t">
      <div class="pt-20 pb-16">

          @if ((pastEvents.length ?? 0 > 0) || isFilterActive || isLoading) {
          <app-public-search-filter [filterBy]="['sports', 'country', 'length']"
                                    [countries]="countries"
                                    [sports]="sports"
                                    [disableFutureMonths]="true"
                                    [lengthRanges]="lengthRanges"
                                    [showLayoutButton]="false"
                                    [handleQueryParamsChange]="true"
                                    (onFilterChange)="filterChanged($event)">
          </app-public-search-filter>

          @if (!(pastEvents.length ?? 0 > 0 ) && isFilterActive) {
          <app-empty-state [contentKeys]="['empty.state.profile.no.results.title']"
                           [contentKeysSecondary]="['empty.state.profile.no.results.search']"
                           [backgroundColor]="'white'" [paddingBottom]="'300px'"
                           [imgSrc]="'trophy-light.svg'"/>
          }
          @else {
            @if (!isMobile) {
              <div class="py-10">
                 <ng-template [ngTemplateOutlet]="resultsTable"></ng-template>
                </div>
            } @else {
             <app-user-event-grid-list [userEvents]="pastEvents!"
                                    [leftButtonKey]="'event.item.all.results'"
                                    [rightButtonKey]="'event.item.my.result'"
                                    [type]="UserEventGridItemType.FINISHED"
                                    (onLeftButtonClickCallback)="goToEventDetailsPage($event)"
                                    (onRightButtonClickCallback)="openResults($event)"
                                    [languages]="languages"/>
             }
          }
            <app-loader [isLoading]="isLoading"></app-loader>
        } @else if (pastEvents.length > 0) {
          <app-empty-state [contentKeys]="['empty.state.profile.no.results.title']"
                           [contentKeysSecondary]="['empty.state.profile.no.results.registered.user.description']"
                           [backgroundColor]="'white'"
                           [imgSrc]="'trophy-light.svg'" [paddingBottom]="'300px'"
                           [buttonText]="'app.common.browse.events'" (onButtonClick)="goToEventCalendar()"/>
        } @else {
          <app-empty-state [contentKeys]="['empty.state.profile.no.results.title']"
                           [contentKeysSecondary]="['empty.state.profile.no.results.new.user.description']"
                           [backgroundColor]="'white'"
                           [imgSrc]="'trophy-light.svg'" [paddingBottom]="'300px'"
                           [buttonText]="'app.common.browse.events'" (onButtonClick)="goToEventCalendar()"/>
        }
      </div>

    <ng-template #resultsTable>
      <div class="table-wrapper">
          <table class="table results-table"
                 infinite-scroll
                 [infiniteScrollDistance]="1"
                 (scrolled)="loadMore()">
              <thead>
              <tr>
                  <th>{{ t('app.common.event') }}</th>
                  <th>{{ t('app.common.race') }}</th>
                  <th>{{ t('app.common.sport') }}</th>
                  <th>{{ t('app.common.date') }}</th>
                  <th>{{ t('app.common.waypoint.location') }}</th>
                  <th class="text-end">{{ t('competitor.table.time') }}</th>
                  <th class="text-end">{{ t('competitor.table.distance') }}</th>
                  <th class="text-end">{{ t('competitor.table.absolute.rank') }}</th>
                  <th></th>
                  <th></th>
              </tr>
              </thead>
              <tbody>
                @for (item of pastEvents; track item) {
                <tr>
                    <td>
                        <div class="d-flex align-items-center" [ngbTooltip]="item.event?.name" placement="top">
                            <span class="fw-400 fs-14 trim-text-second-line">{{ item.event?.name }}</span>
                        </div>
                    </td>
                    <td>
                        <div class="d-flex align-items-center" [ngbTooltip]="item.race?.name" placement="top">
                            <span class="fw-400 fs-14 trim-text-second-line">{{ item.race?.name }}</span>
                        </div>
                    </td>
                    <td>
                        <div class="d-flex align-items-center">
                            @if (item?.race?.sport) {
                            <div class="tag">
                            <p> {{t("app.common.sports." + item?.race?.sport)}} </p>
                            </div>
                            }
                        </div>
                    </td>
                    <td>
                        <div class="d-flex align-items-center justify-content-start fs-14">
                            <span class="fw-500">{{ item.race?.raceStart | localizedDate:'shortDate' }}</span>
                        </div>
                    </td>
                    <td>
                        <div class="d-flex align-items-center justify-content-center">
                            <span [class]="'fi fi-'+ ((item?.event?.country | country:'isoCode') | lowercase)" style="border-radius: 4px;"></span>
                        </div>
                    </td>
                    <td>
                        <div class="d-flex align-items-center justify-content-end fs-14">
                            <div>
                                {{item.result?.competitorResultsDetail | resultsTotalTime:item.race?.raceSettings?.measurementType:item.race?.raceSettings?.measurementPrecisionType}}
                           </div>
                      </div>
                    </td>
                    <td>
                        <div class="d-flex align-items-center justify-content-end fs-14">
                          <div>
                              {{(item.result?.competitorResultsDetail | competitorDistance:item.race) | raceLengthFormat:undefined:"m"}}
                          </div>
                        </div>
                    </td>
                    <td>
                      <div class="d-flex align-items-center justify-content-end">
                          <div>
                            {{ (item.result?.categoryRank || item.result?.sexRank || item.result?.absoluteRank) ?
                            '#' + (item.result?.categoryRank || item.result?.sexRank || item.result?.absoluteRank) : item.result?.status }}
                           </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex align-items-center justify-content-center">
                          <div>
                              <app-button-alt (onClickCallback)="openResults(item)"
                                              [buttonHeight]="'35px'"
                                              [text]="t('app.user.profile.result')"
                                              [isFullWidth]="false" [fontSize]="'14px'"></app-button-alt>
                          </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex align-items-center justify-content-center dropdown dropdown--remove-arrow" ngbDropdown container="body" placement="bottom-end">
                        <button class="btn-icon" ngbDropdownToggle>
                          <i class="fas fa-ellipsis-v"></i>
                        </button>
                        <div ngbDropdownMenu>
                          <button ngbDropdownItem (click)="goToEventDetailsPage(item)">
                            {{ t('event.item.all.results') }}
                          </button>
                        </div>
                      </div>
                    </td>
                </tr>
                }
              </tbody>
          </table>
      </div>
    </ng-template>

</ng-container>
